/*
 * TUMLE: open the cart drawer the moment "Læg i kurv" is pressed, instead of
 * after the add-to-cart round trip (~0.5-0.8 s, plus the free e-book the cart
 * app adds after it).
 *
 * The drawer is the Kaching Cart app's. It is opened through its own
 * window.kachingCartApi.openCart(); while the add is still on its way the
 * drawer's "empty cart" text is swapped for "Lægger i kurven..." (html class
 * tumle_cart-adding, styles in tumle_main-product.css), and the app fills the
 * drawer when the add lands. Listens on window in the capture phase because
 * the app stops the click before it reaches the button. The sticky bar presses
 * this same button, so it is covered too.
 */
(function () {
  if (window.__tumleInstantCart) return;
  window.__tumleInstantCart = true;

  var ADDING = 'tumle_cart-adding';
  var GIVE_UP_MS = 6000;
  var timer = null;
  var observer = null;

  function done() {
    document.documentElement.classList.remove(ADDING);
    clearTimeout(timer);
    if (observer) observer.disconnect();
    observer = null;
  }

  // The add has landed once the drawer shows a line instead of the empty state
  function watchDrawer() {
    var drawer = document.getElementById('kaching-cart');
    if (!drawer) return;
    observer = new MutationObserver(function () {
      if (!drawer.querySelector('.kaching-cart__empty-cart-content')) done();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  window.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('product-form [type="submit"], product-form button[name="add"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      var api = window.kachingCartApi;
      if (!api || typeof api.openCart !== 'function') return;

      document.documentElement.classList.add(ADDING);
      clearTimeout(timer);
      timer = setTimeout(done, GIVE_UP_MS);
      if (!observer) watchDrawer();
      api.openCart();
    },
    true
  );
})();
